import { faTrash, faEdit, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { deleteData, getData, putData } from '../lib/utils';
import Header from '../components/Headers/Header';

const ClientTable = () => {
  const [tableData, setTableData] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  const plans = ['No Plan', 'On Demand', 'Pro', 'Unlimited Plan'];
  const statuses = ['Active', 'Not Active'];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("admin/all-admin");
        console.log("Fetched data:", response);
        setTableData(response);
      } catch (error) {
        console.error("Error fetching admin data:", error);
      }
    };
    fetchData();
  }, []);

  const handleDelete = async(_id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this row?');
    if (confirmDelete) {
      setTableData(prevData => prevData.filter(item => item._id !== _id));

     const res = await deleteData(`admin/deleteAdmin/${_id}`);
     if(res)
     {
      console.log("response... ",res)
     }

    }
  };

  const handleEditClick = (row) => {
    setEditRowId(row._id);
    setEditFormData({
      ...row,
      status: row.status || "Active",
      plan: row.plan || "No Plan",
      credits: row.credits || 0
    });
  };

  const handleEditChange = (e, field) => {
    let value = e.target.value;
    if (field === 'credits') {
      value = value === '' ? '' : parseFloat(value);
    }
    setEditFormData({ ...editFormData, [field]: value });
  };

  const handleUpdate = async (_id) => {
    setTableData(prevData =>
      prevData.map(item => item._id === _id ? { ...editFormData, _id } : item)
    );

    try {
      const obj = editFormData;
      const response = await putData(`admin/admin-update/${_id}`, {obj});
      if (response) {
        console.log("Update Response:", response);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }

    setEditRowId(null);
    setEditFormData({});
  };

  return (
    <>
      <Header />
      <div className="overflow-x-auto p-4">
        <div className='w-full text-center p-4 font-bold text-lg'>SUPER ADMIN PANEL</div>
        <table className="min-w-full border border-gray-400">
          <thead className="bg-gray-300">
            <tr>
              {[
                'Name', 'Company Name', 'Email', 'Website',
                'Company Size', 'Media Type', 'Job Type',
                'Client Size', 'Status', 'Plan', 'Role', 'Actions', 'Login', 'Credits'
              ].map((header, index) => (
                <th
                  key={index}
                  className="text-sm text-center p-2 border border-gray-400 font-semibold"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row) => {
              const isEditing = editRowId === row._id;
              return (
                <tr key={row._id} className="hover:bg-gray-100 text-center">
                  {[
                    'name', 'companyName', 'email', 'websiteUrl',
                    'companySize', 'mediaType', 'jobType', 'numberOfClients'
                  ].map((field, i) => (
                    <td key={i} className="p-2 border border-gray-300">
                      {isEditing ? (
                        <input
                          type="text"
                          value={editFormData[field] || ''}
                          onChange={(e) => handleEditChange(e, field)}
                          className="border w-full p-1"
                        />
                      ) : (
                        row[field]
                      )}
                    </td>
                  ))}

                  {/* Status */}
                  <td className="p-2 border border-gray-300">
                    {isEditing ? (
                      <select
                        value={editFormData.status}
                        onChange={(e) => handleEditChange(e, 'status')}
                        className="border p-1 rounded w-full text-center"
                      >
                        {statuses.map((status, i) => (
                          <option key={i} value={status}>{status}</option>
                        ))}
                      </select>
                    ) : String(row.status)}
                  </td>

                  {/* Plan */}
                  <td className="p-2 border border-gray-300">
                    {isEditing ? (
                      <select
                        value={editFormData.plan}
                        onChange={(e) => handleEditChange(e, 'plan')}
                        className="border p-1 rounded w-full text-center"
                      >
                        {plans.map((plan, i) => (
                          <option key={i} value={plan}>{plan}</option>
                        ))}
                      </select>
                    ) : row.plan}
                  </td>

                  {/* Role */}
                  <td className="p-2 border border-gray-300">
                    {isEditing ? (
                      <input
                        type="text"
                        value={editFormData.role || ''}
                        onChange={(e) => handleEditChange(e, 'role')}
                        className="border w-full p-1"
                      />
                    ) : row.role}
                  </td>

                  {/* Actions */}
                  <td className="p-2 border border-gray-300 flex justify-center space-x-2">
                    {isEditing ? (
                      <button
                        onClick={() => handleUpdate(row._id)}
                        className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    ) : (
                      <button
                        onClick={() => handleEditClick(row)}
                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    )}
                    <button
                      onClick={() => handleDelete(row._id)}
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>

                  {/* Login */}
                  <td className="p-2 border border-gray-300">
                    <button
                      onClick={async () => {
                        const response = await getData(`admin/impersonate/${row._id}`);
                        if (response?.url) {
                          window.open(response.url, "_blank");
                        }
                      }}
                      id={row._id}
                      className="bg-purple-600 text-white px-3 py-1 rounded hover:bg-purple-700"
                    >
                      Login
                    </button>
                  </td>

                  {/* Credits */}
                  <td className="p-2 border border-gray-300">
                    {isEditing ? (
                      <input
                        type="number"
                        step="0.01"
                        value={editFormData.credits ?? ''}
                        onChange={(e) => handleEditChange(e, 'credits')}
                        className="border w-full p-1"
                      />
                    ) : (
                      row.credits !== undefined && row.credits !== null
                        ? (row.credits / 1024 / 5).toFixed(2)
                        : ''
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ClientTable;
